/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'
import { Box } from '@chakra-ui/react'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const CloudUploadIconOutline = createIcon({
  displayName: 'CloudUploadIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <line
        xmlns="http://www.w3.org/2000/svg"
        x1="15"
        y1="15"
        x2="12"
        y2="12"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        xmlns="http://www.w3.org/2000/svg"
        x1="12"
        y1="12"
        x2="9"
        y2="15"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        xmlns="http://www.w3.org/2000/svg"
        x1="12"
        y1="20"
        x2="12"
        y2="12"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M8,19H6a4,4,0,0,1-4-4H2a4,4,0,0,1,4-4H6l-.01-.07036A6.07106,6.07106,0,0,1,12,4h0a6.07106,6.07106,0,0,1,6.01,6.92964L18,11h0a4,4,0,0,1,4,4h0a4,4,0,0,1-4,4H16"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <rect xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" />
    </>
  ),
})

const CloudUploadIconFilled = createIcon({
  displayName: 'CloudUploadIconFilled',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box
        as="line"
        xmlns="http://www.w3.org/2000/svg"
        x1="15"
        y1="15"
        x2="12"
        y2="12"
        fill="none"
        stroke="primary.500"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <Box
        as="line"
        xmlns="http://www.w3.org/2000/svg"
        x1="12"
        y1="12"
        x2="9"
        y2="15"
        fill="none"
        stroke="primary.500"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <Box
        as="line"
        xmlns="http://www.w3.org/2000/svg"
        x1="12"
        y1="20"
        x2="12"
        y2="12"
        fill="none"
        stroke="primary.500"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M8,19H6a4,4,0,0,1-4-4H2a4,4,0,0,1,4-4H6l-.01-.07036A6.07106,6.07106,0,0,1,12,4h0a6.07106,6.07106,0,0,1,6.01,6.92964L18,11h0a4,4,0,0,1,4,4h0a4,4,0,0,1-4,4H16"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <rect xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" />
    </>
  ),
})

const CloudUpload: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
    case 'filled':
      return <CustomIcon as={CloudUploadIconFilled} {...props} />
    default:
      return <CustomIcon as={CloudUploadIconOutline} {...props} />
  }
}

export default memo(CloudUpload)
